import { createContext, useContext, useState, ReactNode } from 'react';

interface BuilderHeaderState {
  state?: {
    zoom?: number;
    viewMode?: 'desktop' | 'tablet' | 'mobile';
    isSaving?: boolean;
    saveStatus?: 'idle' | 'saving' | 'success' | 'error';
    history?: {
      past: unknown[];
      future: unknown[];
    };
  };
  dispatch?: (action: { type: string; payload?: unknown }) => void;
}

interface BuilderHeaderContextType {
  builderState: BuilderHeaderState | null;
  setBuilderState: (state: BuilderHeaderState | null) => void;
  showPreview: boolean;
  setShowPreview: (show: boolean) => void;
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (value: boolean) => void;
}

const BuilderHeaderContext = createContext<
  BuilderHeaderContextType | undefined
>(undefined);

export const BuilderHeaderProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [builderState, setBuilderState] = useState<BuilderHeaderState | null>(
    null
  );
  const [showPreview, setShowPreview] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  return (
    <BuilderHeaderContext.Provider
      value={{ builderState, setBuilderState, showPreview, setShowPreview, hasUnsavedChanges, setHasUnsavedChanges }}
    >
      {children}
    </BuilderHeaderContext.Provider>
  );
};

export const useBuilderHeader = () => {
  const context = useContext(BuilderHeaderContext);
  if (!context) {
    return {
      builderState: null,
      setBuilderState: () => {},
      showPreview: false,
      setShowPreview: () => {},
      hasUnsavedChanges: false,
      setHasUnsavedChanges: () => {},
    };
  }
  return context;
};
